export default "__VITE_ASSET__zaqfTmDP__"